import { smoothScroll } from "../../utils/Constants";
import Breadcrumbs from "../../styles/components/Breadcrumbs";
import "../../styles/pages/content/_about.scss";

export default function About() {
    return (
        <div className="about-page" id="about">
            {/* ── Hero ── */}
            <section className="section-hero">
                <div className="hero-inner">
                    <Breadcrumbs
                        items={[
                            { label: "Home", href: "/" },
                            { label: "About", href: "/about" },
                        ]}
                    />

                    {/* <div className="hero-label">Our mission</div> */}

                    <h1 className="hero-heading">
                        We help you master the&nbsp;art of interviewing
                    </h1>

                    <p className="hero-body">
                        Mooz is a video interview platform built to sharpen
                        communication through guided practice. Our intuitive
                        interface helps you craft strong responses and handle
                        tricky questions with confidence.
                    </p>

                    <a
                        href="#origins"
                        className="btn-origins"
                        onClick={smoothScroll}
                    >
                        <span>Read our story</span>
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            aria-hidden="true"
                        >
                            <path
                                d="M8 3v10M3 8l5 5 5-5"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </a>
                </div>

                {/* todo: reinstate with real stats */}
                {/* <div className="hero-stat-strip">
                    <div className="stat">
                        <span className="stat-number">10k+</span>
                        <span className="stat-label">Practice sessions</span>
                    </div>
                    <div className="stat-divider" aria-hidden="true" />
                    <div className="stat">
                        <span className="stat-number">94%</span>
                        <span className="stat-label">Feel more confident</span>
                    </div>
                    <div className="stat-divider" aria-hidden="true" />
                    <div className="stat">
                        <span className="stat-number">150+</span>
                        <span className="stat-label">Question categories</span>
                    </div>
                </div> */}
            </section>

            {/* ── Founders story ── */}
            <section className="section-story" id="origins">
                <div className="story-inner">
                    <div className="story-meta">
                        <span className="story-tag">Foundations</span>
                        <div className="story-portrait-wrap">
                            <img
                                src={require("../../assets/joycekadibu.jpg")}
                                alt="Joyce Kadibu, founder of Mooz"
                                className="story-portrait"
                            />
                            <div className="portrait-ring" aria-hidden="true" />
                        </div>
                        <a
                            className="story-name"
                            href="https://joycekadibu.com/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Joyce Kadibu
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                aria-hidden="true"
                            >
                                <path
                                    d="M2 12L12 2M12 2H5M12 2v7"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </a>
                        <span className="story-role">
                            Founder &amp; Software Engineer
                        </span>
                    </div>

                    <div className="story-content">
                        <h2 className="story-heading">
                            Built from a personal need to feel one step ahead
                        </h2>
                        <p>
                            The inception of Mooz began during a pivotal moment
                            in my educational career at Imperial College London.
                            Nearing the end of my Software Engineering course, I
                            held both excitement and uncertainty about the
                            future. As I prepared for job applications, I wanted
                            to strengthen my interview skills and decided to
                            build a platform tailored to my own needs, which
                            became the foundation of Mooz.
                        </p>
                        <p>
                            What started as a small personal project soon
                            evolved. Through conversations with others, I
                            realised how many shared the same interview
                            anxieties. Today, Mooz is a tool designed to empower
                            aspiring professionals and early career individuals
                            with the skills and self-assurance to succeed in the
                            competitive job market.
                        </p>
                    </div>
                </div>
            </section>

            {/* ── Values ── */}
            <section className="section-values">
                <div className="values-inner">
                    <span className="values-tag">What we stand for</span>
                    <h2 className="values-heading">Principles that guide us</h2>

                    <div className="values-grid">
                        {[
                            {
                                icon: (
                                    <svg
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        aria-hidden="true"
                                    >
                                        <circle
                                            cx="11"
                                            cy="11"
                                            r="9"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            d="M7 11l3 3 5-5"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                ),
                                title: "Confidence-first",
                                body: "Every feature is designed to reduce anxiety and help you walk into interviews feeling ready, not rattled.",
                            },
                            {
                                icon: (
                                    <svg
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        aria-hidden="true"
                                    >
                                        <path
                                            d="M3 11h16M11 3v16"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                ),
                                title: "Continuous growth",
                                body: "We believe preparation is a skill, not a talent. Mooz is built so that every session makes you a little sharper.",
                            },
                            {
                                icon: (
                                    <svg
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        aria-hidden="true"
                                    >
                                        <rect
                                            x="3"
                                            y="3"
                                            width="16"
                                            height="16"
                                            rx="3"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            d="M7 11h8M7 7h8M7 15h5"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                ),
                                title: "Clarity in feedback",
                                body: "Vague feedback doesn't help anyone. We focus on actionable, specific insights you can put to work immediately.",
                            },
                        ].map((v) => (
                            <div className="value-card" key={v.title}>
                                <div className="value-icon">{v.icon}</div>
                                <h3 className="value-title">{v.title}</h3>
                                <p className="value-body">{v.body}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── CTA ── */}
            <section className="section-cta">
                <div className="cta-inner">
                    <span className="cta-tag">Looking ahead</span>
                    <h2 className="cta-heading">
                        Your feedback shapes what we build next
                    </h2>
                    <p className="cta-body">
                        Mooz is continuously evolving. Our vision is simple:
                        build a user-centric platform that makes practicing
                        interviews feel natural. Help us get there by sharing
                        your thoughts.
                    </p>
                    <a
                        className="btn-feedback"
                        href="https://forms.gle/KMqV3RAYBK9XUXsW7"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Share your feedback
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            aria-hidden="true"
                        >
                            <path
                                d="M3 8h10M9 4l4 4-4 4"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </a>
                </div>
            </section>
        </div>
    );
}
